<template>
  <footer class="c-footer">
    <div class="c-footer__navi">
      <div class="c-footer__naviChild">
        <a class="c-footer__logoST50" :href="urls.page_top">
          <img v-if="logoFile" :src="`${assets_path}images/common/${logoFile}`" :alt="logoAlt" width="234" height="15">
        </a>
      </div>

      <div class="c-footer__naviChild f-Cal-Reg">
        <ul v-if="note.links" class="c-footer__pages">
          <li><a :href="urls.page_top">{{note.links.page_top}}</a></li>
          <li><a :href="urls.page_benefit">{{note.links.page_benefit}}</a></li>
          <li><a :href="urls.page_technology">{{note.links.page_technology}}</a></li>
          <li><a :href="urls.page_product">{{note.links.page_product}}</a></li>
        </ul>
      </div>

      <div v-if="lang === 'ja'" class="c-footer__naviChild f-Cal-Reg">
        <ul class="c-footer__pages">
          <li><a href="https://www.citizen.co.jp/policy/index.html" target="_blank"><span>-</span>SITE POLICY</a></li>
          <li><a href="https://www.citizen.co.jp/policy/privacy.html" target="_blank"><span>-</span>PRIVACY POLICY</a></li>
          <li><a href="https://faq-citizen.dga.jp/form/contact.html" target="_blank"><span>-</span>CONTACT</a></li>
        </ul>
      </div>

      <div v-if="note.links" class="c-footer__naviChild c-footer__naviChild--sns f-Cal-Reg">
        <p class="c-footer__naviChild__cap"><span>-</span>{{note.links.official}}</p>
        <ul class="c-footer__sns">
          <li v-if="lang === 'zh-cmn-Hans'" @click="openQR('weibo')" @mouseenter="mouseenter('weibo')" @mouseleave="mouseleave('weibo')">
            <img class="icon-weibo" :src="`${assets_path}images/common/icon-weibo.png`" alt="weibo" width="26" height="20">
            <picture v-if="qrWeibo">
              <source media="(max-width: 900px)" :srcset="`${assets_path}images/common/qr/weibo-sp.png`" />
              <img ref="qr-weibo" class="c-footer__snsQR" :src="`${assets_path}images/common/qr/weibo-pc.png`" alt="" width="125" height="134" />
            </picture>
          </li>
          <li v-if="lang === 'zh-cmn-Hans'" @click="openQR('wechat')" @mouseenter="mouseenter('wechat')" @mouseleave="mouseleave('wechat')">
            <img class="icon-wechat" :src="`${assets_path}images/common/icon-wechat.svg`" alt="wechat" width="24" height="20">
            <picture v-if="qrWechat">
              <source media="(max-width: 900px)" :srcset="`${assets_path}images/common/qr/wechat-sp.png`" />
              <img class="c-footer__snsQR" :src="`${assets_path}images/common/qr/wechat-pc.png`" alt="" width="125" height="134" />
            </picture>
          </li>
          <li v-if="urls.fb"><a :href="urls.fb" target="_blank"><img class="icon-fb" :src="`${assets_path}images/common/icon-fb.svg`" alt="facebook" width="10" height="21"></a></li>
          <li v-if="urls.tw"><a :href="urls.tw" target="_blank"><img class="icon-tw" :src="`${assets_path}images/common/icon-tw.svg`" alt="twitter" width="21" height="17"></a></li>
          <li v-if="urls.insta"><a :href="urls.insta" target="_blank"><img class="icon-insta" :src="`${assets_path}images/common/icon-insta.svg`" alt="instagram" width="19" height="19"></a></li>
          <li v-if="urls.yt"><a :href="urls.yt" target="_blank"><img class="icon-yt" :src="`${assets_path}images/common/icon-yt.svg`" alt="youtube" width="20" height="14"></a></li>
        </ul>
      </div>
    </div>

    <div class="c-footer__links">
      <a class="c-footer__btnSite" :href="urls.citizen" target="_blank">
        <img :src="`${assets_path}images/common/logo-site.svg`" alt="CITIZEN BETTER STARTS NOW" width="105" height="31">
      </a>
      <a class="c-footer__btnGlobal" :href="urls.globalnetwork" target="_blank">
        <img :src="`${assets_path}images/common/logo-global-full.png`" alt="CITIZEN GLOBAL NETWORK" width="94" height="64">
      </a>
    </div>

    <div class="c-footer__cr f-Cal-Reg">
      <span v-html="copyright"></span>
    </div>
  </footer>
</template>

<script>
  import { assets_path } from '@/_modules/utils/variables'
  import store from '@/_modules/stores';

  export default {
    data() {
      return {
        lang: '',
        urls: {},
        note: {},
        assets_path: assets_path,
        copyright: '',
        logoAlt: '',
        logoFile: '',
        qrWeibo: false,
        qrWechat: false
      }
    },
    store,
    computed: {},
    created() {},
    mounted() {
      this.lang = this.$store.getters.getLang;
      this.note = this.$store.getters.getNote;
      this.urls = this.$store.getters.getUrls;
      this.copyright = this.createCopyRight();
      this.ua = this.$store.getters.getUA;

      //console.log(this.ua.device);

      if (this.lang === "zh-cmn-Hans") {
        // sc
        this.logoFile = 'logo-st-sc.svg';
        this.logoAlt = '舒博钛';
      } else {
        this.logoFile = 'logo-st.svg';
        this.logoAlt = 'SUPER TITANIUM';
      }
    },
    methods: {
      onAnchor(e) {
        this.$_onAnchor(e);
      },
      triggerLinks() {
        if (this.$store.getters.isShowLinks) {
          this.$store.commit('setShowLinks', false);
        } else {
          this.$store.commit('setShowLinks', true);
        }
      },
      createCopyRight() {
        const myDate = new Date();
        const theYear = myDate.getFullYear();
        return `&copy;Copyright ${theYear} Citizen Watch Co., Ltd.All rights reserved`;
      },
      openQR(sns) {
        if (sns === 'weibo') {
          if (this.qrWeibo) {
            this.qrWeibo = false;
          } else {
            this.qrWeibo = true;
            this.qrWechat = false;
          }
        } else if (sns === 'wechat') {
          if (this.qrWechat) {
            this.qrWechat = false;
          } else {
            this.qrWechat = true;
            this.qrWeibo = false;
          }
        }
      },
      showQR(sns) {
        if (sns === 'weibo') {
          this.qrWeibo = true;
          this.qrWechat = false;
        } else if (sns === 'wechat') {
          this.qrWechat = true;
          this.qrWeibo = false;
        }
      },
      hideQR(sns) {
        if (sns === 'weibo') {
          this.qrWeibo = false;
        } else if (sns === 'wechat') {
          this.qrWechat = false;
        }
      },
      mouseenter(sns) {
        if (this.ua.device.type !== 'mobile' && this.ua.device.type !== 'tablet') {
          this.showQR(sns);
        }
      },
      mouseleave(sns) {
        if (this.ua.device.type !== 'mobile' && this.ua.device.type !== 'tablet') {
          this.hideQR(sns);
        }
      }
    }
  }
</script>
